import { Suspense, lazy } from 'react';

// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import { Outlet } from 'react-router-dom';
// hooks
import { useAuthContext } from 'src/auth/hooks';
import AccountChangePassword from 'src/sections/userAdmin/account-change-password';
import { el } from 'date-fns/locale';

// ----------------------------------------------------------------------
// PHAN TICH
const OverviewAnalyticsPage = lazy(
  () => import('src/sections/overview/analytics/view/overview-analytics-view')
);

// DANH MỤC CẤU HÌNH
const VBCCCNPage = lazy(() => import('src/pages/dashboard/danhmuc/vbcccn'));
const VBCCCNDetailPage = lazy(() => import('src/pages/dashboard/danhmuc/vbcccn_detail'));
const CongtyPage = lazy(() => import('src/pages/dashboard/danhmuc/congty'));
const NhaThauPage = lazy(() => import('src/pages/dashboard/danhmuc/nhathau'));
const NhaThauAnalyticsPage = lazy(() => import('src/pages/dashboard/danhmuc/nhathau_analytics'));
const NhaThauLogRQPage = lazy(() => import('src/pages/dashboard/danhmuc/nhathau_log_rq'));
const BanDoThangTienView = lazy(() => import('src/pages/dashboard/danhmuc/bandothangtien'));
const ThuThachView = lazy(() => import('src/pages/dashboard/danhmuc/thuthach'));

// DANH MỤC ĐÀO TẠO
const KhoaHocPage = lazy(() => import('src/pages/dashboard/daotao/khoahoc'));
const KhoaHocEditPage = lazy(() => import('src/pages/dashboard/daotao/khoahoc_edit'));
const KhoaHocChiTiet = lazy(() => import('src/pages/dashboard/daotao/khoahoc_chitiet'));

// DANH MỤC GIẢNG VIÊN
const GiangVienPage = lazy(() => import('src/pages/dashboard/daotao/giangvien'));

// DANH MỤC CÂU HỎI
const NganHangCauHoiPage = lazy(() => import('src/pages/dashboard/daotao/nhch'));
const NganHangCauHoiViewPage = lazy(() => import('src/pages/dashboard/daotao/nhch_edit'));
const NganHangCauHoiDetailViewPage = lazy(() => import('src/pages/dashboard/daotao/nhch_detail'));

// DANH MỤC LỚP HỌC
const LopHocPage = lazy(() => import('src/pages/dashboard/daotao/lophoc'));
const LopHocChiTietPage = lazy(() => import('src/pages/dashboard/daotao/lophoc_chitiet'));
const LopHocUpdatePage = lazy(() => import('src/pages/dashboard/daotao/lophoc_edit'));
const LopHocLichHocPage = lazy(() => import('src/pages/dashboard/daotao/lophoc_lichhoc'));
const LopHocHocVienPage = lazy(() => import('src/pages/dashboard/daotao/lophoc_hocvien'));
const LopHocDiemDanhPage = lazy(() => import('src/pages/dashboard/daotao/lophoc_diemdanh'));
const LopHocChamThiPage = lazy(() => import('src/pages/dashboard/daotao/lophoc_chamthi'));

// DANH MỤC BÀI THI
const BaiThiPage = lazy(() => import('src/pages/dashboard/daotao/baithi'));
const BaiThiUpdatePage = lazy(() => import('src/pages/dashboard/daotao/baithi_edit'));
const BaiThiNewPage = lazy(() => import('src/pages/dashboard/daotao/baithi_new'));

// ĐĂNG KÝ
const DangKyPage = lazy(() => import('src/pages/dashboard/daotao/dangky'));

// DANH MỤC CHỨNG CHỈ
const ChungChiPage = lazy(() => import('src/pages/dashboard/daotao/chungchi'));
const ChungChiUpdatePage = lazy(() => import('src/pages/dashboard/daotao/chungchi_edit'));

// TÀI LIỆU
const TailieuListView = lazy(() => import('src/pages/dashboard/danhmuc/tailieu'));
const ChucVuVBCCView = lazy(() => import('src/pages/dashboard/danhmuc/chucvu_vbcc'));
// -----------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: <OverviewAnalyticsPage />,
        index: true,
      },

      { path: 'phan-tich', element: <OverviewAnalyticsPage /> },
      {
        path: 'profile',
        children: [{ path: 'change-password', element: <AccountChangePassword />, index: true }],
      },
      {
        path: 'danh-muc-cau-hinh',
        children: [
          { element: <CongtyPage />, index: true },
          { path: 'van-bang-chung-chi', element: <VBCCCNPage /> },
          { path: 'van-bang-chung-chi/:id', element: <VBCCCNDetailPage /> },
          { path: 'cong-ty', element: <CongtyPage /> },
          { path: 'nha-thau', element: <NhaThauPage /> },
          { path: 'tai-lieu', element: <TailieuListView /> },
          { path: 'chuc-vu', element: <ChucVuVBCCView /> },
          { path: 'ban-do-thang-tien', element: <BanDoThangTienView /> },
          { path: 'thu-thach', element: <ThuThachView /> }
        ],
      },
      {
        path: 'danh-muc-dao-tao',
        children: [
          { path: 'khoa-hoc', element: <KhoaHocPage /> },
          { path: 'giang-vien', element: <GiangVienPage /> },
          // { path: 'lop-hoc', element: <LopHocPage /> },
          { path: 'ngan-hang-cau-hoi', element: <NganHangCauHoiPage /> },
          { path: 'ngan-hang-cau-hoi/view', element: <NganHangCauHoiViewPage /> },
          { path: 'ngan-hang-cau-hoi/:id', element: <NganHangCauHoiDetailViewPage /> },
          { path: 'khoa-hoc/:id', element: <KhoaHocEditPage /> },
          { path: ':id', element: <KhoaHocChiTiet /> },
          {
            path: 'chung-chi',
            children: [
              { element: <ChungChiPage />, index: true },
              { path: '', element: <ChungChiPage /> },
              { path: 'view', element: <ChungChiUpdatePage /> },
            ],
          },
          {
            path: 'lop-hoc',
            children: [
              { element: <LopHocPage />, index: true },
              { path: '', element: <LopHocPage /> },
              { path: ':id/detail', element: <LopHocChiTietPage /> },
              { path: ':id/edit', element: <LopHocUpdatePage /> },
              { path: 'new', element: <LopHocUpdatePage /> },
              { path: ':id/lich-hoc', element: <LopHocLichHocPage /> },
              { path: ':id/hoc-vien', element: <LopHocHocVienPage /> },
              { path: ':id/diem-danh', element: <LopHocDiemDanhPage /> },
              { path: ':id/cham-thi', element: <LopHocChamThiPage /> },
            ],
          },
          {
            path: 'bai-thi',
            children: [
              { element: <BaiThiPage />, index: true },

              { path: '', element: <BaiThiPage /> },
              { path: ':id/qlch', element: <BaiThiUpdatePage /> },
              { path: 'new', element: <BaiThiNewPage /> },
              { path: ':id/edit', element: <BaiThiNewPage /> },
            ],
          },
          {
            path: 'dang-ky',
            children: [
              { element: <DangKyPage />, index: true },
              { path: '', element: <DangKyPage /> },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'nha-thau',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: <NhaThauPage />,
        index: true,
      },
      {
        path: 'nhan-su',
        element: <NhaThauPage />,
      },
      {
        path: 'bao-cao',
        element: <NhaThauAnalyticsPage />,
      },
      {
        path: 'yeu-cau',
        element: <NhaThauLogRQPage />,
      }
    ],
  },
];
